import React, { FC, useContext } from 'react';

import { FormControl, FormLabel } from '@material-ui/core';
import NoteIcon from '@material-ui/icons/Feedback';

import { GlobalContext } from '../../../../../../../../store';

import { PlayerNotesStyled } from './PlayerNotes.Styles';

export const PlayerNotes: FC = () => {
  const {
    playerEditorModal: { enrollment }
  } = useContext(GlobalContext);

  if (!enrollment || !enrollment.playerNote) {
    return <></>;
  }

  return (
    <PlayerNotesStyled>
      <FormControl classes={{ root: 'formcontrol-container' }} component="fieldset">
        <FormLabel component="legend">
          <NoteIcon className="comment-icon" color="primary" />
          NOTE TO EVENT ADMIN
        </FormLabel>

        <div className="playerNote">{enrollment.playerNote}</div>
      </FormControl>
    </PlayerNotesStyled>
  );
};
